import React from 'react';
import { BarChart2, AreaChart as AreaChartIcon, PieChart as PieChartIcon, ScatterChart as ScatterChartIcon, Type as TypeIcon, Globe, Share2, FlaskConical, Grid, Move, Box, Flame, Target } from 'lucide-react';
import { ChartConfig } from '../types';

const ChartTypePicker: React.FC<{ value: ChartConfig['type'] | undefined, onSelect: (t: ChartConfig['type']) => void }> = ({ value, onSelect }) => {
    const Item: React.FC<{ t: ChartConfig['type'], label: string, icon: React.ReactElement }> = ({ t, label, icon }) => {
        const active = value === t;
        return (
            <button type="button" onClick={() => onSelect(t)} className={`group relative flex items-center gap-2 p-2 rounded-lg border text-left transition-all duration-200 ${active ? 'border-neon-gold bg-neon-gold/10 shadow-[0_0_20px_rgba(245,158,11,0.4)] ring-1 ring-neon-gold/50' : 'border-white/10 hover:border-white/30 bg-white/5 hover:bg-white/10'}`} title={label}>
                {React.cloneElement(icon as React.ReactElement<any>, { className: `${(t === 'scatter' || t === 'number' || t === 'scientific') ? 'w-5 h-5' : 'w-4 h-4'} transition-colors ${active ? 'text-neon-gold drop-shadow-[0_0_8px_rgba(245,158,11,0.8)]' : 'text-gray-500 group-hover:text-neon-gold'}` })}
                <span className={`text-xs font-medium transition-colors ${active ? 'text-neon-gold drop-shadow-[0_0_5px_rgba(245,158,11,0.5)]' : 'text-white/80 group-hover:text-white'}`}>{label}</span>
                {['3d-bar', 'globe', '3d'].includes(t) && (<span className="absolute top-1 right-1 text-[9px] px-1 py-0.5 rounded bg-neon-gold/10 text-neon-gold border border-neon-gold/20 shadow-[0_0_10px_rgba(245,158,11,0.2)]">3D</span>)}
            </button>
        );
    };
    return (
        <div className="space-y-3">
            <div className="text-[10px] font-bold text-neon-gold/50 uppercase tracking-widest">Standard Charts</div>
            <div className="grid grid-cols-2 gap-2">
                <Item t="bar" label="Bar" icon={<BarChart2 />} />
                <Item t="line" label="Line" icon={<AreaChartIcon />} />
                <Item t="area" label="Area" icon={<AreaChartIcon />} />
                <Item t="pie" label="Pie" icon={<PieChartIcon />} />
                <Item t="scatter" label="Scatter" icon={<ScatterChartIcon />} />
                <Item t="number" label="Number" icon={<TypeIcon />} />
                <Item t="kpi-card" label="KPI Card" icon={<Target />} />
            </div>
            <div className="text-[10px] font-bold text-neon-gold/50 uppercase tracking-widest mt-4">Advanced</div>
            <div className="grid grid-cols-2 gap-2">

                <Item t="map" label="Map Chart" icon={<Globe />} />
                <Item t="force-directed" label="Force Graph" icon={<Share2 />} />
                <Item t="3d-bar" label="3D Bar" icon={<BarChart2 />} />
                <Item t="scientific" label="Scientific" icon={<FlaskConical />} />
                <Item t="3d" label="3D Scatter" icon={<Box />} />
                <Item t="heatmap" label="Heatmap" icon={<Flame />} />
            </div>
        </div>
    );
};

export default ChartTypePicker;
